export const styles = theme => ({
  sublist: {
    backgroundColor: 'inherit',
    padding: 0
  },

  list: {
    width: '100%',
    maxWidth: 360,
    position: 'relative',
    overflow: 'auto',
    backgroundColor: theme.palette.background.paper,
    maxHeight: 400,
    padding: 0
  },

  listSection: {
    backgroundColor: 'inherit',
  },
})



// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/UserHistory/styles.js